<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <v-btn
          block
          min-height="200px"
          color="primary"
          style="font-size: 30px"
          :outlined="contractorOutlined"
          @click="contractorClickedHandler"
        >
          Contractor
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          block
          min-height="200px"
          color="primary"
          style="font-size: 30px"
          :outlined="permPlacementOutlined"
          @click="permPlacementClickedHandler"
        >
          Permanent<br>Placement
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          block
          min-height="200px"
          color="primary"
          style="font-size: 30px"
          :outlined="projectOutlined"
          :disabled="disableProjectOption"
          @click="projectClickedHandler"
        >
          Project
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { CONTRACTOR, PERMANENT_PLACEMENT, PROJECT } from '@/lib/constants/dealAssignmentTypes'

export default {
  props: [
    'readonly',
    'disableProjectOption'
  ],
  computed: {
    ...mapFields('dealV2', ['deal']),
    contractorOutlined () {
      return !this.deal.dealAssignmentType ? true : this.deal.dealAssignmentType !== CONTRACTOR
    },
    permPlacementOutlined () {
      return !this.deal.dealAssignmentType ? true : this.deal.dealAssignmentType !== PERMANENT_PLACEMENT
    },
    projectOutlined () {
      return !this.deal.dealAssignmentType ? true : this.deal.dealAssignmentType !== PROJECT
    }
  },
  methods: {
    contractorClickedHandler () {
      if (!this.readonly) {
        this.setDealAssignmentType(CONTRACTOR)
      }
    },
    permPlacementClickedHandler () {
      if (!this.readonly) {
        this.setDealAssignmentType(PERMANENT_PLACEMENT)
      }
    },
    projectClickedHandler () {
      if (!this.readonly) {
        this.setDealAssignmentType(PROJECT)
      }
    },
    setDealAssignmentType (dealAssignmentType) {
      this.$emit('setDealAssignmentType', dealAssignmentType)
    },
    isAssignmentTypeValid () {
      return !this.deal.dealAssignmentType ? 'Please select an option to proceed' : true
    }
  }
}
</script>
